import React,{ useState } from 'react'
import { useHistory } from 'react-router-dom';

const Signin = (props) => {
    const [credendials, setCredentials] = useState({ email: "", password: "" });
    let history = useHistory();
    const handleSubmit = async (e) => {
        e.preventDefault();
        // const response = await fetch('http://localhost:5000/api/auth/login', {
        const response = await fetch('https://inotebook05.herokuapp.com/api/auth/login', {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: credendials.email, password: credendials.password })
        });
        const json = await response.json();
        console.log(json);
        if (json.success) {
            // save auth token & redirect
            localStorage.setItem('token', json.authToken);
            props.showAlert('Logged in!', 'success');
            history.push('/');
        }
        else {
            props.showAlert('Invalid Credentials', 'danger');
        }
    }

    const onChange = (e) => {
        setCredentials({ ...credendials, [e.target.name]: e.target.value })
    }

    return (
        <div className="container  m-auto" >
            <h3 className='my-3 mb-2'>Login to continue to iNoteBook!</h3>
            <form className='mt-2' onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email address</label>
                    <input type="email" className="form-control" value={credendials.email} onChange={onChange} id="email" name="email" aria-describedby="emailHelp"/>
                    <div id="emailHelp" className ="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input type="password" className="form-control" value={credendials.password} onChange={onChange} id="password" name="password"/>
                </div>
                <button type="submit" className="btn btn-primary">Submit</button>
            </form>
        </div>
    )
}

export default Signin
